/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface OutgoingTaxCodesSearchConditions { 
    pageSize?: number;
    page?: number;
    readonly listSortDirection?: OutgoingTaxCodesSearchConditions.ListSortDirectionEnum;
    sortDirection?: string;
    sortProperty?: string;
    searchTerm?: string;
    taxClauseCode?: Array<string>;
    activityCodeGroupId?: Array<number>;
    taxClauseDescription?: Array<string>;
    taxPercentage?: Array<number>;
    euTaxCodeIdentifier?: Array<string>;
    taxCodeIdentifier?: Array<string>;
    isBlocked?: Array<OutgoingTaxCodesSearchConditions.IsBlockedEnum>;
    vatCustomerType?: Array<OutgoingTaxCodesSearchConditions.VatCustomerTypeEnum>;
    vatTransportType?: Array<OutgoingTaxCodesSearchConditions.VatTransportTypeEnum>;
}
export namespace OutgoingTaxCodesSearchConditions {
    export type ListSortDirectionEnum = 0 | 1;
    export const ListSortDirectionEnum = {
        NUMBER_0: 0 as ListSortDirectionEnum,
        NUMBER_1: 1 as ListSortDirectionEnum
    };
    export type IsBlockedEnum = '0' | '1';
    export const IsBlockedEnum = {
        _0: '0' as IsBlockedEnum,
        _1: '1' as IsBlockedEnum
    };
    export type VatCustomerTypeEnum = '0' | '1' | '2' | '3' | '4';
    export const VatCustomerTypeEnum = {
        _0: '0' as VatCustomerTypeEnum,
        _1: '1' as VatCustomerTypeEnum,
        _2: '2' as VatCustomerTypeEnum,
        _3: '3' as VatCustomerTypeEnum,
        _4: '4' as VatCustomerTypeEnum
    };
    export type VatTransportTypeEnum = '0' | '1' | '2' | '3' | '4';
    export const VatTransportTypeEnum = {
        _0: '0' as VatTransportTypeEnum,
        _1: '1' as VatTransportTypeEnum,
        _2: '2' as VatTransportTypeEnum,
        _3: '3' as VatTransportTypeEnum,
        _4: '4' as VatTransportTypeEnum
    };
}